import axios from "axios";

/** 在线地图省市区 JSON 数据地址 */
const MAP_DATA_URL =
  "https://l-xpert.obs.cn-southwest-2.myhuaweicloud.com/backstage/0486d34d-3628-9884-ad73-99572bca111e.json";

/** 缓存的地图数据 */
let mapDataCache = null;
/** 获取地图数据的 Promise 缓存 */
let mapDataPromise = null;

/**
 * 异步获取中国省市区街道地图数据（防并发且支持强缓存）
 * @returns {Promise<Object>} 地图省市区树形结构数据
 */
export function fetchMapData() {
  if (mapDataCache) return Promise.resolve(mapDataCache);
  if (mapDataPromise) return mapDataPromise;
  mapDataPromise = axios
    .get(MAP_DATA_URL)
    .then((res) => {
      mapDataCache = res.data || {};
      return mapDataCache;
    })
    .catch((err) => {
      mapDataPromise = null;
      throw err;
    });
  return mapDataPromise;
}
